export default "__VITE_ASSET__CY80Cybi__"